<template>
  <div>
    <transition name="modal">
      <div class="modal-mask modalmask modal-mask-height">
        <div class="modal-wrapper">
          <div class="modal-dialog modal-sm">
            <div class="d-flex justify-content-center">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {}
</script>
<style>
.modal-mask {
  position: fixed;
  z-index: 9000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modalmask {
  color: rgb(105, 6, 23);
  height: 110%;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-header {
  border-bottom: none;
}
</style>
